import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { translations } from '../../data/i18n';
import { siteConfig } from '../../data/site';

const FooterWrap = styled.footer`
  background: var(--black);
  color: var(--white);
  padding: 28px;
  border-top: 1px solid rgba(255,255,255,0.08);
  margin-top: auto;
`;

const Inner = styled.div`
  max-width: var(--container);
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  font-size: 0.9rem;
`;

const Copy = styled.div`
  color: rgba(255,255,255,0.78);
`;

const Links = styled.div`
  display: flex;
  gap: 20px;

  a {
    color: var(--white);
    opacity: 0.9;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 0.82rem;
  }

  a:hover {
    color: var(--gold-light);
  }
`;

function Footer({ language }) {
  const t = translations[language].footer;

  return (
    <FooterWrap>
      <Inner>
        <Copy>
          © {new Date().getFullYear()} {siteConfig.brandName} · {siteConfig.tagline}
        </Copy>

        <Links>
          <Link to="/impressum">{t.imprint}</Link>
          <Link to="/datenschutz">{t.privacy}</Link>
        </Links>
      </Inner>
    </FooterWrap>
  );
}

export default Footer;